import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";

import Loader from "../../components/ui/Loader";
import Text from "../../components/ui/Text";
import Touchable from "../../components/ui/Touchable";
import { tabletMaxWidth } from "../../constants/layout";
import useCtaStore from "../../hooks/store/useCtaStore";
import useStore from "../../hooks/store/useStore";
import useNavigateWithParams from "../../hooks/useNavigateWithParams";
import BookButton from "../../pages/bookDemo/BookButton";
import CaringCta from "../../pages/caringCta/CaringCta";
import { GameSourcePageMapping } from "../../services/EventTracking/mapping";
import cn from "../../utils/cn";
import { SourceType } from "../../types";
import { gameMapping, magicPenMaxWidth } from "./constants";

export default function GameLayout() {
  const { t } = useTranslation();
  const navigateWithParams = useNavigateWithParams();

  const { source, selectedGame, setSelectedGame } = useStore(
    (state) => state.global,
  );
  const { showingCtaETId } = useCtaStore((state) => state.cta);

  useEffect(() => {
    if (!selectedGame) navigateWithParams();
  }, [selectedGame, navigateWithParams]);

  if (source === SourceType.DemoApp) return <div>Page Not Found</div>;

  if (!selectedGame) return <Loader />;

  const isMagicPen = selectedGame === "magicPen";

  const layoutMaxWidth = isMagicPen ? magicPenMaxWidth : tabletMaxWidth;

  const displayBookButton = !isMagicPen && source === SourceType.ClubApp;

  const handleBack = () => {
    navigateWithParams();
    setSelectedGame(null);
  };

  return (
    <div
      className={cn(
        "relative flex min-h-screen w-full justify-center",
        isMagicPen
          ? "hide-scrollbar overflow-y-auto bg-[#ffe5d1]"
          : "overflow-hidden bg-pink1",
      )}
    >
      <div
        className="flex min-h-screen w-full min-w-[320px] flex-col bg-pink1"
        style={{ maxWidth: layoutMaxWidth }}
      >
        <Touchable
          className="relative z-10 flex h-11 w-full shrink-0 cursor-pointer items-center"
          onClick={handleBack}
        >
          <ChevronLeft className="mx-1 size-6 text-orange" />

          <Text normal>{t("playing")}</Text>
        </Touchable>

        {gameMapping[selectedGame]}

        <BookButton
          sourcePage={GameSourcePageMapping[selectedGame]}
          displayBookButton={displayBookButton}
        />

        {showingCtaETId ? (
          <CaringCta ctaExperienceTypeId={showingCtaETId} />
        ) : null}
      </div>
    </div>
  );
}
